import { useUpdateMe } from '@/api/auth';
import type { AgentStatus } from '@/api/types';
import { StatusDot, useToast } from '@/components/ui';
import { useAuth } from '../auth/useAuth';

const OPTIONS: { value: AgentStatus; label: string }[] = [
  { value: 'online', label: 'Online' },
  { value: 'away', label: 'Away' },
  { value: 'busy', label: 'Busy' },
  { value: 'offline', label: 'Offline' },
];

/** Agent availability — drives routing (only online agents get new chats/tickets). */
export function StatusSwitcher() {
  const { user } = useAuth();
  const update = useUpdateMe();
  const toast = useToast();

  return (
    <label className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white py-1 pr-1 pl-2.5 text-sm">
      <StatusDot status={user.status} />
      <span className="sr-only">Your availability</span>
      <select
        value={user.status}
        onChange={(e) =>
          update.mutate(
            { status: e.target.value as AgentStatus },
            { onError: (err) => toast.error(err.message) },
          )
        }
        className="cursor-pointer bg-transparent py-1 pr-1 font-medium text-slate-700 focus:outline-none"
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </label>
  );
}
